/** Detect inline OpenPGP armor in a message body. */
export function looksLikePgpMessage(text: string): boolean {
  return (text || '').includes('-----BEGIN PGP MESSAGE-----');
}

export function looksLikePgpSigned(text: string): boolean {
  return (text || '').includes('-----BEGIN PGP SIGNED MESSAGE-----');
}

export function looksLikePgpPayload(text: string): boolean {
  return looksLikePgpMessage(text) || looksLikePgpSigned(text);
}

/** Prefer plain text for PGP operations; fall back to HTML stripped lightly. */
export function pgpSourceText(bodyText?: string | null, bodyHtml?: string | null): string {
  if (bodyText && looksLikePgpPayload(bodyText)) return bodyText;
  if (bodyHtml && looksLikePgpPayload(bodyHtml)) return bodyHtml;
  return bodyText || bodyHtml || '';
}
